import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


import Menu from "./menu";
import Admin from "./Admin";
import Login from "./login";
import AdminDashboard from "./AdminDashboard";
import EditDish from "./EditDish";


function App() {
  return (
    <Router>
     
      
      <Routes>
        <Route path="/" element={<Menu />} />
        <Route path="/login" element={<Login />} />
         <Route path="/admindash" element={<AdminDashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/edit-dish/:id" element={<EditDish />} />
      </Routes>
    </Router>
  );
}

export default App;
